import { useMemo } from 'react';

import { NameAndCreateDateFormatter, TruncateWithTooltipFormatter } from '@Components/Grid/components/Table/formatters';
import { defaultColumn, defaultActionsColumn, deleteAction, editAction, toggleFormatter, defaultColumnId } from '@Components/Grid/utils/column';

export default function useColumns() {
  return useMemo(() => [
    defaultColumnId(),
    defaultColumn('name', 'Description', info => <NameAndCreateDateFormatter info={info} />, { size: 400 }),
    defaultColumn('key', 'Key', info => <TruncateWithTooltipFormatter info={info} />, { size: 200 }),
    defaultColumn('type'),
    defaultColumn('private', 'Private', toggleFormatter, { size: 80 }),
    defaultActionsColumn(editAction, deleteAction),
  ], [])
}
